'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AutoSaveContainer from 'ContentEditorUI/containers/AutoSaveContainer';
import { getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getSaveData, getCanSave } from '../redux/selectors/saveSelectors';
import { validate } from '../redux/actions/postPublishActions';
import { jsx as _jsx } from "react/jsx-runtime";
const keysForHardSave = ['name', 'slug', 'blog_author_id', 'topic_ids', 'campaign', 'campaign_name', 'campaign_utm', 'content_group_id'];
const keysToReload = [
// changes require preview reload
'content_group_id', 'blog_author_id', 'topic_ids', 'head_html', 'featured_image'];
const mapStateToProps = (state, ownProps) => {
  const hasContentModel = getHasContentModel(state);
  return {
    saveData: ownProps.isAppReadyForSaving && hasContentModel ? getSaveData(state) : null,
    canSave: getCanSave(state)
  };
};
const mapDispatchToProps = {
  validate
};
class BlogAutoSaveContainer extends Component {
  render() {
    const {
      saveData,
      autoSave,
      autoSaveDebounced,
      canSave
    } = this.props;
    if (!saveData) {
      return null;
    }
    return /*#__PURE__*/_jsx(AutoSaveContainer, {
      autoSaveDebounced: autoSaveDebounced,
      autoSave: autoSave,
      saveData: saveData,
      canSave: canSave,
      keysForHardSave: keysForHardSave,
      keysToReload: keysToReload,
      validate: this.props.validate
    });
  }
}
BlogAutoSaveContainer.propTypes = {
  saveData: PropTypes.object,
  canSave: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  isAppReadyForSaving: PropTypes.bool.isRequired,
  // Just used in getting the saveData
  autoSaveDebounced: PropTypes.func.isRequired,
  autoSave: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(BlogAutoSaveContainer);